// src/App.js
import React from "react";
import { ThemeProvider } from "./context/ThemeContext";
import GlobalStyles from "./GlobalStyles";

import Navbar from "./components/Navbar";
import MobileNav from "./components/MobileNav";

import Hero from "./sections/Hero";
import About from "./sections/About";
import Skills from "./sections/Skills";
import Experience from "./sections/Experience";
import Projects from "./sections/Projects";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";

function App() {
  return (
    <ThemeProvider>
      <GlobalStyles />

      {/* Navigation */}
      <Navbar />
      <MobileNav />

      {/* Main content */}
      <main id="main" role="main">
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Contact />
      </main>

      <Footer />
    </ThemeProvider>
  );
}

export default App;
